/**
 * QR Code schema terms
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const qrCode = {
	valueData: {
		label: "schema:qrCode.valueData#label",
		description: "schema:qrCode.valueData#description"
	},
	valueDataValues: {
		text: {
			label: "schema:qrCode.valueData#values.text#label"
		},
		link: {
			label: "schema:qrCode.valueData#values.link#label"
		}
	},
	errorCorrectionLevel: {
		label: "schema:qrCode.errorCorrectionLevel#label",
		description: "schema:qrCode.errorCorrectionLevel#description"
	}
};
